var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.hidden ? 'd-none saving-wrapper' : 'saving-wrapper d-inline-block ml-2'},[_c('div',{staticClass:"widget-saving",class:_vm.hasError ? 'text-danger' : 'text-success'},[_vm._v("\n        "+_vm._s(_vm.savedFraze)+"\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9ff550","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/elements/WidgetSaving.vue
// module id = uhWM
// module chunks = 1 2